import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Legend, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { FaInfoCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';
import '../stylesheets/components/Charts.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Legend, Tooltip);

const TopicsBarChart = ({
  title = 'Topics Identified vs Topics Taken to Conversation',
  subtitle = 'Text or Description',
  labels = ['Demands', 'Control', 'Management Support', 'Peer Support', 'Relationships', 'Role'],
  topicsData = [12, 10, 15, 28, 14, 25],
  takenData = [8, 7, 10, 18, 10, 20],
  topicsLabel = 'Number of Topics Found',
  takenLabel = 'Taken to Conversation',
  topicsColor = '#165BAA',
  takenColor = '#A155B9',
  infoTooltip = '',
}) => {
  const data = {
    labels,
    datasets: [
      {
        label: topicsLabel,
        data: topicsData,
        backgroundColor: topicsColor,
        borderRadius: 0,
        barPercentage: 0.9,
        categoryPercentage: 0.7,
      },
      {
        label: takenLabel,
        data: takenData,
        backgroundColor: takenColor,
        borderRadius: 0,
        barPercentage: 0.9,
        categoryPercentage: 0.7,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false
      },      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 16,
          boxHeight: 8,
          font: { size: 12, weight: 400 },
          color: '#888',
          padding: 16,
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: '#888',
          font: { size: 12 },
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false, // Force all labels to show
        },
        stacked: false,
      },
      y: {
        beginAtZero: true,
        grid: { color: '#eee' },
        ticks: {
          color: '#888',
          font: { size: 12 },
          stepSize: Math.max(...[...Object.values(topicsData), ...Object.values(takenData)]) >= 10 ? 10 : 2,
          callback: function(value) {
            if (Number.isInteger(value)) return value;
            return null;
          },
        },
        stacked: false,
        max: Math.max(...[...Object.values(topicsData), ...Object.values(takenData)]),
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="chart-card-container">      <div className="chart-card__title-row">
        <span className="chart-card__title">{title}</span>
        <span className="chart-card__icon" title={infoTooltip}>
          <FaInfoCircle size={16} color="#A0A0A0" />
        </span>
      </div>
      <div className="chart-card__subtitle">{subtitle}</div>
      <hr className="chart-card__divider" />
      <div className="chart-bar-area chart-bar-area--scrollable topics-bar-area--tall">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

TopicsBarChart.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  labels: PropTypes.array,
  topicsData: PropTypes.array,
  takenData: PropTypes.array,
  topicsLabel: PropTypes.string,
  takenLabel: PropTypes.string,
  topicsColor: PropTypes.string,
  takenColor: PropTypes.string,
  infoTooltip: PropTypes.string,
};

export default TopicsBarChart;
